<script setup>
import ContentHeader from '@/Components/Content/Header/index.vue';
import Button from '@/Components/Button.vue';
import { computed } from 'vue';
import { usePage } from '@inertiajs/vue3';

const props = defineProps({
  provider: {
    type: Object,
    required: true,
  },
});

const page = usePage();
const context = computed(() => page.props?.context);
const enquiryEnabled = context.value?.enquiry_enabled ?? false;

function addHttps(url) {
  if (url && !url.startsWith('http://') && !url.startsWith('https://')) {
      url = 'https://' + url;
  }
  return url;
}
</script>

<template>
  <ContentHeader
    :image-set="provider.logos"
    :logo-alt-text="provider.name"
  >
    <template #title>
      {{ provider.name }}
    </template>
    <template #subtitle>
      CRICOS CODE: {{ provider.cricos_code }}
    </template>
    <template #actions>

      <li class="h-fit mb-0">
        <Button
          class="w-full"
          variant="outlined"
          type="link"
          :link="`/provider/${provider.slug}/${provider.id}/courses`"
        >
        View Courses
      </Button>
      </li>

      <li class="h-fit mb-0">
        <Button
          class="w-full"
          variant="outlined"
          type="link"
          :link="`/provider/${provider.slug}/${provider.id}/scholarships`"
        >
          View Scholarships
        </Button>
      </li>
      <li v-if="enquiryEnabled" class="h-fit mb-0">
        <Button
          class="w-full"
          variant="primary"
          type="link"
          :link="`/provider/${provider.slug}/${provider.id}/enquiry`"
        >
          Contact Provider
        </Button>
      </li>
      <li v-if="provider.web_address" class="h-fit mb-0">
        <Button
          class="w-full"
          variant="secondary"
          type="link"
          :link="addHttps(provider.web_address)"
          :external="true"
          :link-data="provider.name"
        >
          Visit website
        </Button>
      </li>
    </template>
  </ContentHeader>
</template>
